import * as Yup from 'yup';

import { globalMessages } from '@savgroup-front-common/core/helpers';

const ChoiceProductUniverseModelSchema = Yup.object().shape({
  choiceProductUniverseId: Yup.string().required(globalMessages.form.required),
});

export default ChoiceProductUniverseModelSchema;
